// extracted by mini-css-extract-plugin
export var wrapper = "footer-module--wrapper--dDpbR";